import {
  AmountOption,
  PredefinedAmount,
  SuggestedAmountV1,
} from '@/common/types';

const amountToOption = (
  amountItem: SuggestedAmountV1,
  formatter?: (value: number | string) => string,
  isV2: boolean = false,
): AmountOption => {
  const price = isV2
    ? (amountItem as PredefinedAmount)?.price!
    : (amountItem as SuggestedAmountV1)?.amount!;
  const { amount: numericValue, formattedAmount } = price;
  const label = formatter ? formatter(numericValue!) : formattedAmount!;
  return {
    value: `${numericValue}`,
    amountLabel: label,
    label,
    amountImpact: amountItem.description,
  };
};

export const getSuggestedAmountMapper =
  (formatter?: (value: number | string) => string, isV2: boolean = false) =>
  (suggestedAmount: SuggestedAmountV1): AmountOption =>
    amountToOption(suggestedAmount, formatter, isV2);
